import Layout from '@/layout'

export default [
  {
    path: '/distribute',
    name: 'Distribute',
    component: Layout,
    redirect: '/distribute/certificateAgentList',
    meta: { title: '分销管理', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'certificateAgentList',
        name: 'CertificateAgentList',
        component: () => import('@/views/distribute/agentManage/index'),
        meta: { title: '分销人员管理' },
      },
      {
        path: 'agentDetail',
        name: 'AgentDetail',
        component: () => import('@/views/distribute/agentManage/agentDetail'),
        meta: { title: '代理商详情' },
      },
      {
        path: 'distProduct',
        name: 'DistProduct',
        component: () => import('@/views/distribute/distProduct/index.vue'),
        meta: { title: '分销商品管理' },
      },
      {
        path: 'distRecord',
        name: 'DistRecord',
        component: () => import('@/views/distribute/distRecord/index.vue'),
        meta: { title: '分销记录' },
      },
      {
        path: 'mySalesRecord',
        name: 'MySalesRecord',
        component: () => import('@/views/distribute/MySalesRecord/index.vue'),
        meta: { title: '我的分销' },
      },
      {
        path: 'mySalesRecord/add',
        name: 'MySalesRecordAdd',
        component: () => import('@/views/distribute/MySalesRecord/add'),
        meta: { title: '添加报名信息' },
      },
      {
        path: 'offlineRecordReview',
        name: 'OfflineRecordReview',
        component: () => import('@/views/distribute/OfflineRecordReview/index'),
        meta: { title: '线下分销记录审核' },
      },
    ],
  },
]
